import type { RequestParams } from '@/shared/api';
import type { PackItemListParams } from '../model/types';

export const PACK_KEYS = {
  all: ['pack'] as const,
  list: (params?: RequestParams) => [...PACK_KEYS.all, 'list', params] as const,
  detail: (id: number) => [...PACK_KEYS.all, 'detail', id] as const,
  itemList: (params?: PackItemListParams) => [...PACK_KEYS.all, 'item-list', params] as const,
};
